module.exports = __webpack_public_path__ + "img/PlayersTrust_Icon_RGB.96248beb.png";